import React , {useRef, useState} from 'react'
import axios from "axios";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ClipLoader from "react-spinners/ClipLoader"; 
import { Link } from 'react-router-dom'
import Autocomplete from "react-google-autocomplete";
import ReCAPTCHA from 'react-google-recaptcha';

const SolutionForm = ({ prm }) => {
  // Zoho scope : ZohoCRM.modules.ALL
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const mapApiKey = process.env.REACT_APP_GOOGLE_PLACE_API_KEY;
  const recaptchaKey = process.env.REACT_APP_GOOGLE_RECAPTCHA_KEY;
  const [enquiry, setEnquiry] = useState(prm);
  const [solFirstName, setSolFirstName] = useState("");
  const [solLastName, setSolLastName] = useState("");
  const [solPhone, setSolPhone] = useState("");
  const [solEmail, setSolEmail] = useState("");
  const [solLocation, setSolLocation] = useState("");    
  const [errors, setErrors] = useState({});
  const [isChecked, setIsChecked] = useState(true);
  const [disableButton, setDisableButton] = useState(false);
  const [spinnerClass, setSpinnerClass] = useState('invisible');
  const [isVisible, setIsVisible] = useState('visible');
  const [showMessage, setShowMessage] = useState('invisible');  
  const [msg, setMsg] = useState("");

  const recaptchaRef = useRef(null);
  const [isCaptchaVerified, setIsCaptchaVerified] = useState(false);  
  const [isValidCaptcha, setIsValidCaptcha] = useState("");

  const handleCaptchaChange = (token) => {
    setIsCaptchaVerified(!!token);
  };

  const resetCaptcha = () => {
    recaptchaRef.current?.reset();
    setIsCaptchaVerified(false);
    setIsValidCaptcha("Valid");
    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      setErrors({});
      return;
    }     
  };

  const toggleDisableButton = () => {
    setDisableButton(!disableButton);
    setIsChecked(!isChecked);
  };

  const changeClass = () => {
    setSpinnerClass('visible');
    setIsVisible('invisible');
  };

// Validation function for email and password
  const validateForm = () => {
    const errors = {};
    if (!solFirstName) {
        errors.solFirstName = "First name is required";
    }
    if (!solLastName) {
        errors.solLastName = "Last name is required";
    }
    if (!solPhone) {
        errors.solPhone = "Contact number is required";
    }    
    if (!solLocation) {
        errors.solLocation = "Location is required";
    }
    if (isCaptchaVerified === false) {
      errors.isValidCaptcha = "Please verify the CAPTCHA before submitting";
    }        
    return errors;
  };
  
  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
    if (!isCaptchaVerified) {
      return;
    }    
    changeClass();
    const apiUrl = apiBaseUrl + `sendmail?form_type=3&enquiry_type=${enquiry}&first_name=${solFirstName}&last_name=${solLastName}&contact_number=${solPhone}&email=${solEmail}&location=${solLocation}&message=`;
    await axios.get(apiUrl).then((res)=>{
        setSpinnerClass('invisible');
        setIsVisible('visible');
        setMsg(res.data.msg);
        //console.log('Send Data:', res);
        if (res.data.success === true) {
            toast("Data sent successfully");
            setSolFirstName("");
            setSolLastName("");
            setSolPhone("");
            setSolEmail("");
            setSolLocation("");
            setEnquiry(prm);
            setShowMessage('visible');
        } else {
            toast(res.data.error || "Mail not sent");
        }        
      }).catch((err)=>{
        //console.log('Invalid Email :', err);
        setSpinnerClass('invisible');
        setIsVisible('visible');
        setShowMessage('visible');
        toast("Something went wrong. Please try again later.");
    })
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth' // Optional, for smooth scrolling
    });
  }; 

  return (
    <>
    <form className="appoinment-form row" onSubmit={handleSubmit}> 
        <div className="form-group col-md-6">
            <label>First name <span className="text-danger"><strong>*</strong></span></label>
            <input 
                className="form-control" 
                placeholder="First name" 
                type="text" 
                name="sol_first_name"
                value={solFirstName}
                onChange={(e) => setSolFirstName(e.target.value)}
                autoComplete="false"                            
                required/>
                {errors.solFirstName && <span className="error-message">{errors.solFirstName}</span>}
        </div>
        <div className="form-group col-md-6">
            <label>Last name <span className="text-danger"><strong>*</strong></span></label>
            <input 
                className="form-control" 
                placeholder="Last name" 
                type="text" 
                name="sol_last_name"
                value={solLastName}
                onChange={(e) => setSolLastName(e.target.value)}
                autoComplete="false"                            
                required/>
                {errors.solLastName && <span className="error-message">{errors.solLastName}</span>}
        </div>                                
        <div className="form-group col-md-12">
            <label>Contact number <span className="text-danger"><strong>*</strong></span></label>
            <input 
                className="form-control" 
                placeholder="Contact number" 
                type="text"
                name="sol_contact_number"
                maxLength={10}
                value={solPhone}
                onChange={(e) => setSolPhone(e.target.value)}
                autoComplete="false"                            
                required/>
                {errors.solPhone && <span className="error-message">{errors.solPhone}</span>}
        </div>
        <div className="form-group placeholder-wrap icon-form-outline col-md-12">
            <label>Solar installation location <span className='text-danger'>*</span></label>
            <i className="left fa fa-search"></i>
            <Autocomplete
              apiKey={mapApiKey}
              name="sol_location" 
              className="form-control location-input" 
              type="text"
              placeholder='Solar installation location' 
              onPlaceSelected={(place) => {
                //console.log(place?.formatted_address);
                setSolLocation(place?.formatted_address)
              }}
              options={{
                types: ["(regions)"],
                componentRestrictions: { country: "in" },
              }}
              defaultValue={solLocation}
              required />                
            <i className="right fa fa-map-marker"></i>
            {errors.solLocation && <span className="error-message">{errors.solLocation}</span>}
        </div>                    
        <div className="form-group col-md-12">
            <label>Email</label>
            <input 
                className="form-control" 
                placeholder="Email" 
                type="email"
                name="sol_email"
                value={solEmail}
                onChange={(e) => setSolEmail(e.target.value)}
                autoComplete="false"/>
        </div>
        <div className="form-group col-md-10 col-sm-10 col-lg-10 col-xs-9">
          <ReCAPTCHA
            ref={recaptchaRef}
            sitekey={recaptchaKey}
            className="input-control google-recaptch-wrapper"
            onChange={handleCaptchaChange}
          />  
        </div>
        <div className="col-md-2 col-sm-2 col-lg-2 col-xs-3 text-center">
          <span 
            className="form-control refresh-btn-wrapper" 
            onClick={resetCaptcha}><i className="fa fa-refresh"></i></span>
        </div>
        {errors.isValidCaptcha && 
        <>
        <div className="form-group col-md-12">
          <span className="error-message">{errors.isValidCaptcha}</span>
        </div>
        </>
        }        
        <div className="form-group col-md-12 col-sm-12 col-xs-12">
            <p><input 
                type="checkbox" 
                name="chkPolicy"
                onChange={toggleDisableButton}
                checked = { isChecked } 
                required /> You agree to our <Link to="/privacy-policy" onClick={scrollToTop}>privacy policy</Link>.</p>
        </div>            
        <div className="form-group col-md-12 col-sm-12 col-xs-12 text-center">
            <button 
                className={`${isVisible} btn btn-lg btn-appointment-submit`}
                type="submit" 
                disabled={disableButton}>
                    Request Call Back
            </button>                                    
            <span className={`${spinnerClass} btn btn-lg btn-appointment-submit`}>
                <ClipLoader
                    loading={true}
                    size={30}
                    color={"#ffffff"}/>                            
            </span>                                    
        </div>
        {!!(msg) && (
        <div className="form-group col-md-12 col-sm-12 col-xs-12 custom-message text-center">
          <span className={`${showMessage} text-center text-success`}>{msg}</span>  
        </div>
        )}                  
    </form>
    <ToastContainer/> 
    </>
)  
}

export default SolutionForm